import { LoanStatus, LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { StatusTagType } from '../config/types';
import { FunnelStageStep } from '../types/funnelStageStep';

export const STYLE_PARAMS_BY_STATUS = {
  [LoanStatus.STATUS_INITIAL]: {
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'dark',
    title: FunnelStageStep.STARTED,
    icon: 'arrow_forward',
  },
  [LoanStatusExternal.INITIAL]: {
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'dark',
    title: FunnelStageStep.STARTED,
    icon: 'arrow_forward',
  },
  [LoanStatus.STATUS_ANALYSING]: {
    colorPaletteName: StatusTagType.INFO,
    colorType: 'main',
    title: FunnelStageStep.REQUESTED,
    icon: 'add',
  },
  [LoanStatusExternal.REQUESTED]: {
    colorPaletteName: StatusTagType.INFO,
    colorType: 'main',
    title: FunnelStageStep.REQUESTED,
    icon: 'add',
  },
  [LoanStatusExternal.ON_HOLD]: {
    colorPaletteName: StatusTagType.INFO,
    colorType: 'main',
    title: FunnelStageStep.REQUESTED,
    icon: 'add',
  },
  [LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'dark',
    title: FunnelStageStep.APPROVED,
    icon: 'check',
  },
  [LoanStatusExternal.APPROVED]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'dark',
    title: FunnelStageStep.APPROVED,
    icon: 'check',
  },
  [LoanStatus.STATUS_CONTRACT_SENT]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'dark',
    title: FunnelStageStep.APPROVED,
    icon: 'check',
  },
  [LoanStatus.STATUS_CONTRACT_SIGNED]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'dark',
    title: FunnelStageStep.APPROVED,
    icon: 'done_all',
  },
  [LoanStatusExternal.SIGNED]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'dark',
    title: FunnelStageStep.APPROVED,
    icon: 'done_all',
  },
  [LoanStatus.STATUS_DOCS_APPROVED]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'main',
    title: FunnelStageStep.CONFIRMED,
    icon: 'done_all',
  },
  [LoanStatusExternal.CONFIRMED]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'main',
    title: FunnelStageStep.CONFIRMED,
    icon: 'done_all',
  },
  [LoanStatusExternal.CAPTURED]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'main',
    title: FunnelStageStep.CONFIRMED,
    icon: 'done_all',
  },
  [LoanStatus.STATUS_ACTIVE]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'main',
    title: FunnelStageStep.PAID,
    icon: 'euro',
  },
  [LoanStatus.STATUS_ACTIVE_TRIAL]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'main',
    title: FunnelStageStep.PAID,
    icon: 'euro',
  },
  [LoanStatusExternal.PAID]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'main',
    title: FunnelStageStep.PAID,
    icon: 'euro',
  },
  [LoanStatus.STATUS_DENIED]: {
    colorPaletteName: StatusTagType.ERROR,
    colorType: 'main',
    title: FunnelStageStep.DENIED,
    icon: 'block',
  },
  [LoanStatusExternal.DENIED]: {
    colorPaletteName: StatusTagType.ERROR,
    colorType: 'main',
    title: FunnelStageStep.DENIED,
    icon: 'block',
  },
  [LoanStatus.STATUS_DESISTED]: {
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'main',
    title: FunnelStageStep.DESISTED,
    icon: 'close',
  },
  [LoanStatusExternal.DESISTED]: {
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'main',
    title: FunnelStageStep.DESISTED,
    icon: 'close',
  },
  [LoanStatus.STATUS_CANCELLED]: {
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'main',
    title: FunnelStageStep.CANCELLED,
    icon: 'close',
  },
  [LoanStatusExternal.CANCELLED]: {
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'main',
    title: FunnelStageStep.CANCELLED,
    icon: 'close',
  },
  [LoanStatus.STATUS_CANCELLED_TEST]: {
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'main',
    title: FunnelStageStep.CANCELLED,
    icon: 'close',
  },
  [LoanStatus.STATUS_EXPIRED]: {
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'main',
    title: FunnelStageStep.EXPIRED,
    icon: 'close',
  },
  [LoanStatusExternal.EXPIRED]: {
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'main',
    title: FunnelStageStep.EXPIRED,
    icon: 'close',
  },
} as const satisfies StyleParam;

export interface StyleParam {
  [key: string]: { colorPaletteName: StatusTagType; colorType: 'light' | 'dark' | 'main'; title: string; icon: string };
}
